import script from "./ButtonApp.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonApp.vue?vue&type=script&setup=true&lang=js"

import "./ButtonApp.vue?vue&type=style&index=0&id=62459d2b&lang=scss"

const __exports__ = script;

export default __exports__